import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, Star } from 'lucide-react';

const testimonials = [
  {
    id: 1,
    author: 'Михаил Соколов',
    company: 'ООО "ЭнергоСтройПроект"',
    position: 'Главный инженер',
    quote: 'Сотрудничаем с Проминнова уже более 3 лет. За это время было поставлено более 20 трансформаторов ТСЛ различной мощности. Оборудование отличается высоким качеством и надежностью, а сроки поставки всегда соблюдаются. Отдельно отмечу профессионализм технических специалистов компании.',
    rating: 5,
  },
  {
    id: 2,
    author: 'Елена Дмитриева',
    company: 'АО "ПромСтройКомплекс"',
    position: 'Руководитель отдела закупок',
    quote: 'Выражаем благодарность команде Проминнова за оперативную поставку трансформаторов ТСЗ для нашего проекта. Особенно ценим индивидуальный подход к нашим техническим требованиям и гибкие условия сотрудничества. Планируем продолжать сотрудничество на новых объектах.',
    rating: 5,
  },
  {
    id: 3,
    author: 'Алексей Иванов',
    company: 'ГК "ЭлектроМонтаж"',
    position: 'Технический директор',
    quote: 'Заказывали в Проминнова комплектную поставку КТПН с трансформаторами ТСЛ. Оборудование доставлено в срок, качество на высоте. При монтаже и пусконаладке специалисты компании оказали квалифицированную техническую поддержку. Результатом сотрудничества полностью удовлетворены.',
    rating: 4,
  },
];

const Testimonials: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const goToPrev = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
    );
  };

  const currentTestimonial = testimonials[currentIndex];

  return (
    <section className="py-16 bg-white">
      <div className="container-custom">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Что говорят наши клиенты</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Мы гордимся отзывами наших клиентов, которые ценят качество нашего оборудования и уровень сервиса
          </p>
        </div>
        
        <div className="max-w-4xl mx-auto">
          <div className="relative bg-primary-50 rounded-xl p-8 md:p-12">
            {/* Quote icon */}
            <div className="absolute top-6 left-6 text-primary-200">
              <svg className="w-16 h-16" fill="currentColor" viewBox="0 0 24 24">
                <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
              </svg>
            </div>
            
            {/* Rating */}
            <div className="flex justify-center mb-6">
              {[...Array(5)].map((_, i) => (
                <Star 
                  key={i} 
                  className={`w-6 h-6 ${i < currentTestimonial.rating ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300'}`} 
                />
              ))}
            </div>
            
            {/* Quote */}
            <blockquote className="text-center text-lg md:text-xl text-gray-700 mb-8">
              "{currentTestimonial.quote}"
            </blockquote>
            
            {/* Author */}
            <div className="text-center">
              <div className="font-semibold text-lg">{currentTestimonial.author}</div>
              <div className="text-primary-600">{currentTestimonial.position}</div>
              <div className="text-gray-500 text-sm">{currentTestimonial.company}</div>
            </div>
            
            {/* Navigation */}
            <div className="absolute inset-x-0 bottom-0 flex justify-center -mb-6">
              <div className="flex space-x-2 bg-white rounded-full shadow-md p-1">
                <button
                  onClick={goToPrev}
                  className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors"
                  aria-label="Previous testimonial"
                >
                  <ChevronLeft className="w-5 h-5" />
                </button>
                
                <button
                  onClick={goToNext}
                  className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors"
                  aria-label="Next testimonial"
                >
                  <ChevronRight className="w-5 h-5" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;